export enum BannerType {
  Banner = 1,
  Modal = 2,
}
